// FilePreview.tsx
import React from "react";
import styles from "./FilePreview.module.css";

interface FilePreviewProps {
  file: File;
  previewUrl: string;
  onRemove: () => void;
}

const FilePreview: React.FC<FilePreviewProps> = ({ file, onRemove, previewUrl }) => {
  const isImage = file.type.startsWith("image/");
  const isPDF = file.type === "application/pdf";

  return (
    <div className={styles.previewBox}>
      <button className={styles.removeBtn} onClick={onRemove} aria-label="Remove file" />
      {isImage ? (
        <img src={previewUrl} alt={file.name} className={styles.image} data-testid="file-preview" />
      ) : (
        <a href={previewUrl} target="_blank" rel="noopener noreferrer" className={styles.pdfIcon} />
      )}
      <span className={styles.fileName}>{file.name}</span>
    </div>
  );
};

export default FilePreview;
